export const WS_ZOOM_X = {
  min: 1,
  max: 1500,
  step: 10,
  default: 1,
};

export const WS_SPEED = {
  min: 0.5,
  max: 2,
  step: 0.01,
  default: 1,
};

export const WS_VOLUME = {
  min: 0,
  max: 1,
  step: 0.01,
  default: 1,
};
